export default {
  "menu.CompanyScoreOperateRecordListPage": "场所处罚记录列表",
}